export default __webpack_public_path__ + "static/media/ryan-masc.680a6e96.jpg";